// 220区域
export const PHONE_CODES = [
  {
    value: '+86',
    text: '中国大陆(+86)',
  },
  {
    value: '+852',
    text: '中国香港(+852)',
  },
  {
    value: '+853',
    text: '中国澳门(+853)',
  },
  {
    value: '+886',
    text: '中国台湾(+886)',
  },
  {
    value: '+65',
    text: '新加坡(+65)',
  },
  {
    value: '+93',
    text: '阿富汗(+93)',
  },
  {
    value: '+355',
    text: '阿尔巴尼亚(+355)',
  },
  {
    value: '+213',
    text: '阿尔格拉(+213)',
  },
  {
    value: '+376',
    text: '安道尔(+376)',
  },
  {
    value: '+244',
    text: '安哥拉(+244)',
  },
  {
    value: '+1264',
    text: '安圭拉(+1264)',
  },
  {
    value: '+247',
    text: '阿森松岛(+247)',
  },
  {
    value: '+1268',
    text: '安提瓜和巴布达(+1268)',
  },
  {
    value: '+54',
    text: '阿根廷(+54)',
  },
  {
    value: '+374',
    text: '亚美尼亚(+374)',
  },
  {
    value: '+297',
    text: '阿鲁巴(+297)',
  },
  {
    value: '+61',
    text: '澳大利亚(+61)',
  },
  {
    value: '+43',
    text: '奥地利(+43)',
  },
  {
    value: '+994',
    text: '阿塞拜疆(+994)',
  },
  {
    value: '+1242',
    text: '巴哈马(+1242)',
  },
  {
    value: '+973',
    text: '巴林(+973)',
  },
  {
    value: '+880',
    text: '孟加拉国(+880)',
  },
  {
    value: '+1246',
    text: '巴巴多斯(+1246)',
  },
  {
    value: '+375',
    text: '白俄罗斯(+375)',
  },
  {
    value: '+32',
    text: '比利时(+32)',
  },
  {
    value: '+501',
    text: '伯利兹(+501)',
  },
  {
    value: '+229',
    text: '贝宁(+229)',
  },
  {
    value: '+1441',
    text: '百慕大(+1441)',
  },
  {
    value: '+975',
    text: '不丹(+975)',
  },
  {
    value: '+591',
    text: '玻利维亚(+591)',
  },
  {
    value: '+387',
    text: '波斯尼亚和黑塞哥维那(+387)',
  },
  {
    value: '+267',
    text: '博茨瓦纳(+267)',
  },
  {
    value: '+55',
    text: '巴西(+55)',
  },
  {
    value: '+673',
    text: '文莱(+673)',
  },
  {
    value: '+359',
    text: '保加利亚(+359)',
  },
  {
    value: '+226',
    text: '布基纳法索(+226)',
  },
  {
    value: '+257',
    text: '布隆迪(+257)',
  },
  {
    value: '+855',
    text: '柬埔寨(+855)',
  },
  {
    value: '+237',
    text: '喀麦隆(+237)',
  },
  {
    value: '+1',
    text: '加拿大(+1)',
  },
  {
    value: '+238',
    text: '佛得角(+238)',
  },
  {
    value: '+1345',
    text: '开曼群岛(+1345)',
  },
  {
    value: '+236',
    text: '中非共和国(+236)',
  },
  {
    value: '+235',
    text: '乍得(+235)',
  },
  {
    value: '+56',
    text: '智利(+56)',
  },
  {
    value: '+57',
    text: '哥伦比亚(+57)',
  },
  {
    value: '+269',
    text: '科摩罗(+269)',
  },
  {
    value: '+242',
    text: '刚果共和国(+242)',
  },
  {
    value: '+243',
    text: '刚果民主共和国(+243)',
  },
  {
    value: '+682',
    text: '库克群岛(+682)',
  },
  {
    value: '+506',
    text: '哥斯达黎加(+506)',
  },
  {
    value: '+225',
    text: '科特迪沃(+225)',
  },
  {
    value: '+385',
    text: '克罗地亚(+385)',
  },
  {
    value: '+53',
    text: '古巴(+53)',
  },
  {
    value: '+357',
    text: '塞浦路斯(+357)',
  },
  {
    value: '+420',
    text: '+捷克共和国(+420)',
  },
  {
    value: '+45',
    text: '丹麦(+45)',
  },
  {
    value: '+253',
    text: '吉布提(+253)',
  },
  {
    value: '+1767',
    text: '多米尼克(+1767)',
  },
  {
    value: '+1809',
    text: '多米尼加共和国(+1809)',
  },
  {
    value: '+593',
    text: '厄瓜多尔(+593)',
  },
  {
    value: '+20',
    text: '埃及(+20)',
  },
  {
    value: '+503',
    text: '艾萨尔瓦多(+503)',
  },
  {
    value: '+372',
    text: '爱沙尼亚(+372)',
  },
  {
    value: '+251',
    text: '埃塞俄比亚(+251)',
  },
  {
    value: '+298',
    text: '法罗群岛(+298)',
  },
  {
    value: '+679',
    text: '斐济(+679)',
  },
  {
    value: '+358',
    text: '芬兰(+358)',
  },
  {
    value: '+33',
    text: '法国(+33)',
  },
  {
    value: '+594',
    text: '法属圭亚那(+594)',
  },
  {
    value: '+689',
    text: '法属波利尼西亚(+689)',
  },
  {
    value: '+241',
    text: '加蓬(+241)',
  },
  {
    value: '+220',
    text: '冈比亚(+220)',
  },
  {
    value: '+995',
    text: '格鲁吉亚(+995)',
  },
  {
    value: '+49',
    text: '德国(+49)',
  },
  {
    value: '+233',
    text: '加纳(+233)',
  },
  {
    value: '+350',
    text: '直布罗陀(+350)',
  },
  {
    value: '+30',
    text: '希腊(+30)',
  },
  {
    value: '+299',
    text: '格陵兰(+299)',
  },
  {
    value: '+1473',
    text: '格林纳达(+1473)',
  },
  {
    value: '+590',
    text: '瓜德罗普(+590)',
  },
  {
    value: '+1671',
    text: '关岛(+1671)',
  },
  {
    value: '+502',
    text: '危地马拉(+502)',
  },
  {
    value: '+224',
    text: '几内亚(+224)',
  },
  {
    value: '+44',
    text: '根西(+44)',
  },
  {
    value: '+224',
    text: '几内亚(+224)',
  },
  {
    value: '+592',
    text: '圭亚那(+592)',
  },
  {
    value: '+509',
    text: '海地(+509)',
  },
  {
    value: '+504',
    text: '洪都拉斯(+504)',
  },
  {
    value: '+95',
    text: '缅甸(+95)',
  },
  {
    value: '+36',
    text: '匈牙利(+36)',
  },
  {
    value: '+354',
    text: '冰岛(+354)',
  },
  {
    value: '+91',
    text: '印度(+91)',
  },
  {
    value: '+62',
    text: '印度尼西亚(+62)',
  },
  {
    value: '+98',
    text: '伊朗(+98)',
  },
  {
    value: '+964',
    text: '伊拉克(+964)',
  },
  {
    value: '+353',
    text: '爱尔兰(+353)',
  },
  {
    value: '+44',
    text: '马恩岛(+44)',
  },
  {
    value: '+972',
    text: '以色列(+972)',
  },
  {
    value: '+93',
    text: '意大利(+93)',
  },
  {
    value: '+1876',
    text: '牙买加(+1876)',
  },
  {
    value: '+81',
    text: '日本(+81)',
  },
  {
    value: '+44',
    text: '泽西岛(+44)',
  },
  {
    value: '+962',
    text: '约旦(+962)',
  },
  {
    value: '+7',
    text: '哈萨克斯坦(+7)',
  },
  {
    value: '+254',
    text: '肯尼亚(+254)',
  },
  {
    value: '+383',
    text: '科索沃(+383)',
  },
  {
    value: '+965',
    text: '科威特(+965)',
  },
  {
    value: '+996',
    text: '吉尔吉斯斯坦(+996)',
  },
  {
    value: '+856',
    text: '老挝(+856)',
  },
  {
    value: '+371',
    text: '拉脱维亚(+371)',
  },
  {
    value: '+961',
    text: '黎巴嫩(+961)',
  },
  {
    value: '+266',
    text: '莱索托(+266)',
  },
  {
    value: '+231',
    text: '利比里亚(+231)',
  },
  {
    value: '+218',
    text: '利比亚(+218)',
  },
  {
    value: '+423',
    text: '列支敦士登(+423)',
  },
  {
    value: '+370',
    text: '立陶宛(+370)',
  },
  {
    value: '+352',
    text: '卢森堡(+352)',
  },
  {
    value: '+389',
    text: '马其顿(+389)',
  },
  {
    value: '+261',
    text: '马达加斯加(+261)',
  },
  {
    value: '+265',
    text: '马拉维(+265)',
  },
  {
    value: '+60',
    text: '马来西亚(+60)',
  },
  {
    value: '+960',
    text: '马尔代夫(+960)',
  },
  {
    value: '+223',
    text: '马里(+223)',
  },
  {
    value: '+356',
    text: '马耳他(+356)',
  },
  {
    value: '+596',
    text: '马提尼克(+596)',
  },
  {
    value: '+222',
    text: '毛里塔尼亚(+222)',
  },
  {
    value: '+230',
    text: '毛里求斯(+230)',
  },
  {
    value: '+262',
    text: '马约特(+262)',
  },
  {
    value: '+52',
    text: '墨西哥(+52)',
  },
  {
    value: '+373',
    text: '摩尔多瓦(+373)',
  },
  {
    value: '+377',
    text: '摩纳哥(+377)',
  },
  {
    value: '+976',
    text: '蒙古(+976)',
  },
  {
    value: '+382',
    text: '黑山(+382)',
  },
  {
    value: '+1664',
    text: '蒙特塞拉特(+1664)',
  },
  {
    value: '+212',
    text: '摩洛哥(+212)',
  },
  {
    value: '+258',
    text: '莫桑比克(+258)',
  },
  {
    value: '+264',
    text: '纳米比亚(+264)',
  },
  {
    value: '+977',
    text: '尼泊尔(+977)',
  },
  {
    value: '+31',
    text: '荷兰(+31)',
  },
  {
    value: '+599',
    text: '荷属安的列斯(+599)',
  },
  {
    value: '+687',
    text: '新喀里多尼亚(+687)',
  },
  {
    value: '+64',
    text: '新西兰(+64)',
  },
  {
    value: '+505',
    text: '尼加拉瓜(+505)',
  },
  {
    value: '+227',
    text: '尼日尔(+227)',
  },
  {
    value: '+234',
    text: '尼日利亚(+234)',
  },
  {
    value: '+47',
    text: '挪威(+47)',
  },
  {
    value: '+968',
    text: '阿曼(+968)',
  },
  {
    value: '+92',
    text: '巴基斯坦(+92)',
  },
  {
    value: '+970',
    text: '巴勒斯坦(+970)',
  },
  {
    value: '+507',
    text: '巴拿马(+507)',
  },
  {
    value: '+675',
    text: '巴布亚新几内亚(+675)',
  },
  {
    value: '+595',
    text: '巴拉圭(+595)',
  },
  {
    value: '+51',
    text: '秘鲁(+51)',
  },
  {
    value: '+63',
    text: '菲律宾(+63)',
  },
  {
    value: '+48',
    text: '波兰(+48)',
  },
  {
    value: '+351',
    text: '葡萄牙(+351)',
  },
  {
    value: '+1787',
    text: '波多黎各(+1787)',
  },
  {
    value: '+974',
    text: '库塔(+974)',
  },
  {
    value: '+262',
    text: '留尼汪(+262)',
  },
  {
    value: '+40',
    text: '罗马尼亚(+40)',
  },
  {
    value: '+7',
    text: '俄罗斯(+7)',
  },
  {
    value: '+250',
    text: '卢旺达(+250)',
  },
  {
    value: '+684',
    text: '萨摩亚东部(+684)',
  },
  {
    value: '+685',
    text: '萨摩亚西部(+685)',
  },
  {
    value: '+378',
    text: '圣马力诺(+378)',
  },
  {
    value: '+239',
    text: '圣多美和普林西比(+239)',
  },
  {
    value: '+966',
    text: '沙特阿拉伯(+966)',
  },
  {
    value: '+221',
    text: '塞内加尔(+221)',
  },
  {
    value: '+381',
    text: '塞尔维亚(+381)',
  },
  {
    value: '+248',
    text: '塞舌尔(+248)',
  },
  {
    value: '+232',
    text: '塞拉利昂(+232)',
  },
  {
    value: '+421',
    text: '斯洛伐克(+421)',
  },
  {
    value: '+386',
    text: '斯洛文尼亚(+386)',
  },
  {
    value: '+27',
    text: '南非(+27)',
  },
  {
    value: '+82',
    text: '韩国(+82)',
  },
  {
    value: '+34',
    text: '西班牙(+34)',
  },
  {
    value: '+94',
    text: '斯里兰卡(+94)',
  },
  {
    value: '+1869',
    text: '圣基茨和尼维斯(+1869)',
  },
  {
    value: '+1758',
    text: '圣卢西亚(+1758)',
  },
  {
    value: '+1784',
    text: '圣文森特(+1784)',
  },
  {
    value: '+249',
    text: '苏丹(+249)',
  },
  {
    value: '+597',
    text: '苏里南(+597)',
  },
  {
    value: '+268',
    text: '斯威士兰(+268)',
  },
  {
    value: '+46',
    text: '瑞典(+46)',
  },
  {
    value: '+41',
    text: '瑞士(+41)',
  },
  {
    value: '+963',
    text: '叙利亚(+963)',
  },
  {
    value: '+992',
    text: '塔吉克斯坦(+992)',
  },
  {
    value: '+255',
    text: '坦桑尼亚(+255)',
  },
  {
    value: '+66',
    text: '泰国(+66)',
  },
  {
    value: '+670',
    text: '东帝汶(+670)',
  },
  {
    value: '+228',
    text: '多哥(+228)',
  },
  {
    value: '+676',
    text: '汤加(+676)',
  },
  {
    value: '+1868',
    text: '特立尼达和多巴哥(+1868)',
  },
  {
    value: '+216',
    text: '突尼斯(+216)',
  },
  {
    value: '+90',
    text: '土耳其(+90)',
  },
  {
    value: '+993',
    text: '土库曼斯坦(+993)',
  },
  {
    value: '+1649',
    text: '特克斯和凯科斯群岛(+1649)',
  },
  {
    value: '+256',
    text: '乌干达(+256)',
  },
  {
    value: '+380',
    text: '乌克兰(+380)',
  },
  {
    value: '+971',
    text: '阿拉伯联合酋长国(+971)',
  },
  {
    value: '+44',
    text: '英国(+44)',
  },
  {
    value: '+1',
    text: '美国(+1)',
  },
  {
    value: '+598',
    text: '乌拉圭(+598)',
  },
  {
    value: '+998',
    text: '乌兹别克斯坦(+998)',
  },
  {
    value: '+678',
    text: '瓦努阿图(+678)',
  },
  {
    value: '+58',
    text: '委内瑞拉(+58)',
  },
  {
    value: '+84',
    text: '越南(+84)',
  },
  {
    value: '+1340',
    text: '维尔京群岛(+1340)',
  },
  {
    value: '+967',
    text: '也门(+967)',
  },
  {
    value: '+260',
    text: '赞比亚(+260)',
  },
  {
    value: '+263',
    text: '津巴布韦(+263)',
  },
  {
    value: '+213',
    text: '阿尔及利亚(+213)'
  },
  {
    value: '+225',
    text: '科特迪瓦(+225)'
  },
  {
    value: '+674',
    text: '瑙鲁(+674)'
  },
  {
    value: '+850',
    text: '朝鲜(+850)'
  },
  {
    value: '+974',
    text: '卡塔尔(+974)'
  },
  {
    value: '+677',
    text: '所罗门群岛(+677)'
  },
  {
    value: '+252',
    text: '索马里(+252)'
  },
  {
    value: '+338',
    text: '南斯拉夫(+338)'
  },
];
